// Hamilton interactive, when the DOM is ready
document.addEventListener('DOMContentLoaded', function() {

	// Get the interactive
	var interactive = document.getElementById('hamilton-accordion');

	// Get the subtitles
	var subtitles = interactive.getElementsByTagName('h3');

	// Hide all the sections
	for (var i = subtitles.length - 1; i >= 0; i--) {

		// Add a click event to hide or show the elements
		subtitles[i].addEventListener('click', function(){
			this.classList.toggle('active');

			if ( this.classList.contains('active') ){
				dataLayer.push({
					'category': 'Interactive',
					'action': 'Accordion opened',
					'label': 'Accordion ' + [].slice.call( subtitles ).indexOf( this ),
					'event': 'Interactive'
				});
			}
		});


		//subtitles[i].nextElementSibling.setAttribute('height', subtitles[i].nextElementSibling.offsetHeight + 'px');

		// Hide them
		//subtitles[i].classList.add('hidden');
	}

}, false); // end of Hamilton interactive
